import { render } from "./ListadoArticulos.vue?vue&type=template&id=1c63ad48&scoped=true"
import script from "./ListadoArticulos.vue?vue&type=script&lang=js"
export * from "./ListadoArticulos.vue?vue&type=script&lang=js"

import "./ListadoArticulos.vue?vue&type=style&index=0&id=1c63ad48&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c63ad48"]])

export default __exports__